import { Link } from 'react-router-dom';

export default function CoworkingCTA() {
  return (
    <section
      className="relative py-20 sm:py-28 md:py-36 overflow-hidden"
      aria-labelledby="coworking-cta-heading"
    >
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/175da0e7e93e293ac7885621315d6d27.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="lazy"
          width="1600"
          height="600"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/60"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <h2
          id="coworking-cta-heading"
          className="text-3xl sm:text-4xl md:text-5xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em]"
        >
          今すぐ体験してみませんか？
        </h2>
        <p className="text-sm sm:text-base text-white/60 font-extralight mb-8 sm:mb-10 tracking-wide max-w-lg mx-auto">
          コワーキングスペース by favy（新宿）で、MeVER Chairの座り心地を体感してください。ドロップインなら予約してすぐ利用可能です。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <a
            href="https://appointment.mever.design/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center px-8 sm:px-10 py-3.5 sm:py-4 bg-white text-black text-sm font-medium tracking-[0.1em] hover:bg-white/90 transition-colors whitespace-nowrap rounded-lg cursor-pointer shadow-lg shadow-white/20"
          >
            <i className="ri-calendar-check-line mr-2" aria-hidden="true"></i>
            MeVER Chair 体験予約
            <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
          </a>
          <a
            href="https://pass.workhub.site/spaces/drop-in/detail/KmPzAOl3HSsGdIqqdLxK"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center px-8 sm:px-10 py-3.5 sm:py-4 bg-emerald-500 text-white text-sm font-light tracking-[0.1em] hover:bg-emerald-600 transition-colors whitespace-nowrap rounded-lg cursor-pointer"
          >
            30分単位で使う（550円〜）
            <i className="ri-external-link-line ml-2" aria-hidden="true"></i>
          </a>
          <a
            href="https://forms.gle/kcdbjKEZi2kF7gBB8"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center px-8 sm:px-10 py-3.5 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-sm font-light tracking-[0.1em] hover:bg-white/20 transition-colors whitespace-nowrap rounded-lg cursor-pointer border border-white/20"
          >
            <i className="ri-calendar-line mr-1.5" aria-hidden="true"></i>
            継続利用の内見予約
          </a>
        </div>

        {/* Atelier Folio Cross-promotion */}
        <div className="mt-12 sm:mt-14">
          <Link
            to="/atelier-folio"
            className="group inline-flex items-center gap-3 sm:gap-4 px-5 sm:px-6 py-3 sm:py-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white/10 hover:border-[#8E7AB5]/30 transition-all cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-[#8E7AB5]/15 rounded-lg flex-shrink-0">
              <i className="ri-tablet-line text-[#8E7AB5] text-lg" aria-hidden="true"></i>
            </div>
            <div className="text-left">
              <span className="text-white text-xs sm:text-sm font-medium">Atelier Folio for iPad</span>
              <span className="ml-2 px-1.5 py-0.5 bg-emerald-500/20 text-emerald-400 text-[9px] font-medium rounded-full">NEW</span>
              <p className="text-white/40 text-[11px] sm:text-xs font-light mt-0.5">iPadスタンド＆フォリオケース — 2026年3月公開予定</p>
            </div>
            <i className="ri-arrow-right-s-line text-white/30 group-hover:text-[#8E7AB5] group-hover:translate-x-1 transition-all text-lg" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
